import { RequestTypeDetailQuery } from 'generated/resources/graphql'

interface GetFeatureFlagsResult {
  isProcurementV2FeatureEnabled: boolean
  isVersionHistoryEnabled: boolean
}

export function getFeatureFlags(data?: RequestTypeDetailQuery): GetFeatureFlagsResult {
  const features = data?.features?.featuresConnection?.nodes ?? []

  const isProcurementV2FeatureEnabled = features.some(
    (f) => f.name === 'procurement_v2' && f.enabled
  )

  const isVersionHistoryEnabled = features.some(
    (f) => f.name === 'dev_procurement_type_version_history' && f.enabled
  )

  return { isProcurementV2FeatureEnabled, isVersionHistoryEnabled }
}
